'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconApparelCategory = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M17 1.508h-2.5A2.335 2.335 0 0 1 12 3.623a2.334 2.334 0 0 1-2.5-2.115H7L0 4.893l2 4.653L5 8.7v13.792h14V8.7l3 .846 2-4.654zm4.392 6.975L19.317 7.9 18 7.526v14.12H6V7.526L4.684 7.9l-2.076.586-1.38-3.21 6.038-2.922h1.38A3.475 3.475 0 0 0 12 4.47a3.475 3.475 0 0 0 3.354-2.115h1.38l6.038 2.919zM11.26 10.776l-.778-1.3L8.548 12.7h6.769l-2.579-4.51zm-1.218 1.08l.439-.733.3.5-.136.237h-.6zm1.575 0l1.12-1.961 1.121 1.961z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M17 1.508h-2.5A2.335 2.335 0 0 1 12 3.623a2.334 2.334 0 0 1-2.5-2.115H7L0 4.893l2 4.653L5 8.7v13.792h14V8.7l3 .846 2-4.654zm4.392 6.975L19.317 7.9 18 7.526v14.12H6V7.526L4.684 7.9l-2.076.586-1.38-3.21 6.038-2.922h1.38A3.475 3.475 0 0 0 12 4.47a3.475 3.475 0 0 0 3.354-2.115h1.38l6.038 2.919zM11.26 10.776l-.778-1.3L8.548 12.7h6.769l-2.579-4.51zm-1.218 1.08l.439-.733.3.5-.136.237h-.6zm1.575 0l1.12-1.961 1.121 1.961z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M17 1.508h-2.5A2.335 2.335 0 0 1 12 3.623a2.334 2.334 0 0 1-2.5-2.115H7L0 4.893l2 4.653L5 8.7v13.792h14V8.7l3 .846 2-4.654zm4.392 6.975L19.317 7.9 18 7.526v14.12H6V7.526L4.684 7.9l-2.076.586-1.38-3.21 6.038-2.922h1.38A3.475 3.475 0 0 0 12 4.47a3.475 3.475 0 0 0 3.354-2.115h1.38l6.038 2.919zM11.26 10.776l-.778-1.3L8.548 12.7h6.769l-2.579-4.51zm-1.218 1.08l.439-.733.3.5-.136.237h-.6zm1.575 0l1.12-1.961 1.121 1.961z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconApparelCategory.displayName = 'IconApparelCategory';
exports.default = IconApparelCategory;